import ItemsPage from "../../pages/legacy/items/ItemsPage";

const route = {
  key: "items",
  path: "/legacy/items",
  component: ItemsPage,
  private: true,
  layout: "main",
  icon: "faBox",
  group: "inventory",
  order: 10,
  permission: "legacy.items.access"
};

export default route;